<template>
  <div class="tree-block">
    <!-- 文件夹目录 -->
    <el-tree
      ref="treeRef"
      :data="data"
      node-key="id"
      :default-expanded-keys="defaultExpandKeys"
      :props="propsConfig"
      :expand-on-click-node="false"
      v-bind="attrs"
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
      @node-expand="handleNodeExpand"
    >
      <template #default="{ node, data }">
        <div class="tree-node">
          <div class="tree-node__label">
            <el-icon :size="18" v-if="data.type == 1">
              <svg-icon icon-class="file" />
            </el-icon>
            <p :title="node.label" :class="['tree-node__text', data.id == props.activeId ? 'active' : '']">{{ node.label }}</p>
          </div>

          <div v-if="false">
            <span>
              <el-button type="primary" icon="EditPen" link @click.stop="editNode(node, data)"></el-button>
            </span>
            <span>
              <el-button type="danger" icon="Delete" link @click.stop="delNode(node, data)"></el-button>
            </span>
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  activeId: {
    type: [String, Number],
  },
  defaultExpandKeys: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(['node-click', 'edit', 'remove']);
// watch(() => props.defaultExpandKeys, (newVal) => {
//   if (newVal) {
//     nextTick(() => {
//       let node = treeRef.value.getNode(newVal[0]);
//       treeRef.value.setCurrentNode(node, true);
//       console.log(node);
//       if(node){
//         emits('node-click', node.data, node);
//       }
//     });
//   }
// },{immediate: true,deep: true});

const attrs = useAttrs();
//树形组件dom
const treeRef = useTemplateRef('treeRef');
//树形配置
const propsConfig = reactive({
  label: 'name',
  children: 'children',
});

//点击树节点
function handleNodeClick(data, node) {
  emits('node-click', data, node);
}

//树节点展开
function handleNodeExpand(data, node) {
}

//树节点过滤
function filterNode(value, data, node) {
  if (!value) return true;
  let parentNode = node.parent;
  let labels = [data.name];
  let level = 1;
  while (level < node.level) {
    labels = [...labels, parentNode.label];
    parentNode = parentNode.parent;
    level++;
  }
  return labels.some((label) => label.includes(value));
}

//编辑节点
function editNode(node, data) {
  emits('edit', node, data);
}

//删除节点
function delNode(node, data) {
  emits('remove', node, data);
}

defineExpose({ treeRef });
</script>

<style lang="scss" scoped>
.tree-node {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  .tree-node__label {
    width: 100%;
    user-select: none;
    display: inline-flex;
    align-items: center;
    .tree-node__text {
      width: 100%;
      margin-left: 5px;
      line-height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      &.active {
        color: var(--current-color);
      }
    }
  }
}
</style>
